import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useCapacidadesMutations } from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';

const initialState = {
empresa:'',
codigo: '',
capacidad: ''
};

const NuevaCapacidad = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addCapacidad, updateCapacidadC } = useCapacidadesMutations();

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);

useEffect( () => {
  console.log('entre al Iff + a buscar ' + vecinoData);
},);


  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData._id) 
    {
      // console.log('crear VECINO');
       await addCapacidad.mutateAsync( formData );
    } else
    { 
       await updateCapacidadC.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevocapacidad );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          <div className="flex justify-between items-center">
              <p className="font-semibold text-lg">{!vecinoData ? "Nueva": "Editar" } Capacidad</p>
              <button
                  type="button"
                  onClick={ () => { setIsClicked( !isClicked.nuevocapacidad )} }
                  style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
                  className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                <MdOutlineCancel />
              </button>
          </div>

          <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <label className="text-sm font-semibold mb-1">Maquina</label>
                  <input
                      className="text-xs border border-gray-300 p-2 rounded"
                      type="text"
                      placeholder=""
                      name="codigo"
                      value= {formData.codigo}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1">Capacidad</label>
                    <input
                        className="text-xs border border-gray-300 p-2 rounded"
                        type="text"
                        placeholder=""
                        name="capacidad"
                        value= {formData.capacidad}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>

              </div>


              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                  </button>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevaCapacidad;